import React, { FC, useContext } from 'react';
import styled, { css } from 'styled-components';
import { UiStateContext } from '../../context/UiStateContext';

import { CTACard } from '../CtaCard';
import { MultiSearchProps } from '../search/HeroSearch';
import { RequestAValuationBlade } from '../properties/RequestAValuationBlade';
import {Spacer} from '../Spacer';



interface LocationActionSectionLeftTestProps {
  // name: string;
  // url: string;
  // isArea?: boolean;
  defaultMultisearch?: MultiSearchProps;
}

const StyledCTACard = styled(CTACard)`
  p {
    max-width: 100%;
  }
`

export const LocationActionSectionLeftTest: FC<LocationActionSectionLeftTestProps> = () => {
  const { setActiveBlade } = useContext(UiStateContext);
  return (
    <Spacer>
      <StyledCTACard
        title="Register your property search"
        lead="With over 60 branches across London, our local experts will find the right property for you."
        backgroundColour="grey2"
        customButton={{
          label: 'Find a branch',
          url: '/branches/',
          arrowRight: true,
        }}
      />
      <StyledCTACard
        title="Need a valuation?"
        lead="Our local agents can provide an accurate valuation for your property."
        backgroundColour="brand"
        customButton={{
          label: 'Request a valuation',
          onClick: () => setActiveBlade('propertyRequestAValuation'),
          eventClickBladeId: 'propertyRequestAValuation',
          arrowRight: true,
        }}
      />
      <RequestAValuationBlade />
    </Spacer>
  );
};
